module.exports = __webpack_public_path__ + "img/icon_i_no.35d6c2f1.svg";